import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import {
  cancelLastCardSuccessAction,
  setCardsToStoreAction,
  setHasUndefinedCardToStore,
  setNextCardPositionToStore,
} from 'data/reducers';
import { LastCardCanceledResponse, Notifications } from 'types';

export function* lastCardCanceled({
  type: notificationType,
  data: result,
}: LastCardCanceledResponse) {
  try {
    if (notificationType === Notifications.LAST_CARD_CANCELED) {
      const { cards } = result;
      yield put(cancelLastCardSuccessAction());
      yield put(setCardsToStoreAction(cards));
      yield put(setHasUndefinedCardToStore(false));
      yield put(setNextCardPositionToStore(null));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
